var lib_core = require("lib-core");
var editor_2d = require("editor-2d");
var colors = require("../colors/colors");

var SelectableHandleView = function (gui, handleModel, parentGroup, layers) {
    var self = this;

    this.gui = gui;
    this.handleModel = handleModel;
    this.interactionModel = this.handleModel.parent();

    this.noHandleHighlightUpdate = false; // stop inf loop
    this.svgCircle = null;

    // some data models do not have angles
    if (this.handleModel.modelData != undefined && this.handleModel.modelData.angle != undefined) {
        this.angle = this.handleModel.modelData.angle;
    } else {
        this.angle = null;
    }

    this.cameraModel = this.gui.editorModel.cameraModel();

    this.initGroups(parentGroup, [layers.interaction, layers.interactionControl], handleModel);

    this.svgGroup = this.getGroupInfo(layers.interaction).svgGroup;
    this.controlGroup = this.getGroupInfo(layers.interactionControl).svgGroup;

    this.handleModel.highlighted.onChange(self, function () {
        self.gui.heavyHandler.scheduleHeavy('rebuild_view', self.drawIfNeeded, self, [], self);
    }, 10);

    this.cameraModel.viewS.onChange(self, function () {
        self.gui.heavyHandler.scheduleHeavy('rebuild_view', self.drawIfNeeded, self, [], self);
    }, 10);
    this.handleModel.coord.onChange(self, function () {
        self.gui.heavyHandler.scheduleHeavy('rebuild_view', self.drawIfNeeded, self, [], self);
    }, 10);
    this.interactionModel.infocus.onChange(self, function () {
        self.gui.heavyHandler.scheduleHeavy('rebuild_view', self.drawIfNeeded, self, [], self);
    }, 10);
    if (this.angle != null && this.angle.onChange != undefined) {
        self.angle.onChange(self, function () {
            self.gui.heavyHandler.scheduleHeavy('rebuild_view', self.drawIfNeeded, self, [], self);
        }, 10);
    }

    this.drawIfNeeded();
};

lib_core.mixin(SelectableHandleView, editor_2d.DrawingElement);

module.exports = SelectableHandleView;

/**
 * we want to change the properties of the handle without creating a new one
 */
SelectableHandleView.prototype.configHandle = function() {
    var self = this;
    self.gui.svg.configure(self.svgCircle, {
        cx: self.c.x,
        cy: self.c.y,
        r: self.size/2,
        'fill' : self.handleModel.highlighted() || self.handleModel.selected() ? colors.handleFillSelected : colors.handleFill,
        'stroke': colors.handleStroke,
        'strokeWidth': self.stroke,
        'transform': (self.angle != null ?
            (self.data.angle() ? 'rotate(' + self.data.angle() + ' ' +
            self.hmX + ' ' + self.hmY + ')' : '') : '')
    }, true);
};

SelectableHandleView.prototype.drawIfNeeded = function () {
    if (this.handleModel.isAlive()
        && (this.interactionModel.infocus() || this.handleModel.selected())
        && (!this.handleModel.isHidden || !this.handleModel.isHidden())) {
        this.draw();
    } else {
        this.emptySvgGroups();
    }
};

SelectableHandleView.prototype.draw = function () {
    var self = this;

    $(self.svgGroup).empty();
    $(self.controlGroup).empty();

    self.c = self.handleModel.coord();
    if(self.c != null) {
        self.size = 8 / self.cameraModel.viewS();
        self.stroke = 1 / self.cameraModel.viewS();
        var roundness = 1 / self.cameraModel.viewS();

        self.data = self.handleModel.modelData;
        self.hmX = self.c.getX();
        self.hmY = self.c.getY();

        // draw rect
        self.svgCircle = self.gui.svg.circle(self.svgGroup,
            self.c.x,
            self.c.y,
            self.size/2,
            {
                'fill' : self.handleModel.highlighted() || self.handleModel.selected() ? colors.handleFillSelected : colors.handleFill,
                'stroke': colors.handleStroke,
                'strokeWidth': self.stroke,
                'transform': (self.angle != null ?
                    (self.data.angle() ? 'rotate(' + self.data.angle() + ' ' +
                    self.hmX + ' ' + self.hmY + ')' : '') : '')
            }
        );

        var svgHandle = self.gui.svg.circle(self.controlGroup,
            self.c.x, self.c.y, self.size/2);

        $(svgHandle).mousedown(function (event) {
            return self.onMouseDown(event);
        });
    }
};

SelectableHandleView.prototype.onMouseDown = function (event) {

    // used for center/alt mode
    if(this.interactionModel.updateSessionPos) {
        this.interactionModel.updateSessionPos();
    }
    // used for shift/proportional mode
    if(this.interactionModel.updateSessionAR) {
        this.interactionModel.updateSessionAR();
    }

    var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.ELEMENT_MOUSE_DOWN)
        .fromJSEvent(event)
        .element(this.handleModel)
        .data('mouseCoord', this.gui.relativeMouseCoord(event))
        .data('notFocusable', true);

    return this.gui.stateMachine.handle(cEvent);
};

SelectableHandleView.prototype.clickAction = function () {
};

